// JavaScript Document
jQuery( document ).ready(function($) {
  
  $(".cbox").each(function() {
    $(this).prettyCheckable();
  });
  
  
  function isScrolledTo(elem) {
    var docViewTop = $(window).scrollTop(); //num of pixels hidden above current screen
    var docViewBottom = docViewTop + $(window).height();
    var elemTop = $(elem).offset().top; //num of pixels above the elem
    var elemBottom = elemTop + $(elem).height();
    return ((elemTop <= docViewTop || elemTop >= docViewTop));
  }
  
  
  /*
  var catcher = $('#catcher');
  var sticky = $('#sidebar');
  var footTop = $('footer').offset().top;  
  var lastStickyTop = sticky.offset().top;
  */
  function checkOffset() {
    
    if(isScrolledTo(sticky)){
      sticky.css('position','fixed');
      sticky.css('top','10px');
    }
    
    var stopHeight = catcher.offset().top + catcher.height();
    var stickyFoot = sticky.offset().top + sticky.height();
    
    if (stickyFoot > footTop-10) {
       console.log("Top of Footer");
       sticky.css({
        position:'absolute',
        top: (footTop - 20) - sticky.height()
      });
    }
    
    else {
      if ( stopHeight > sticky.offset().top) {
        console.log("Default position");
        sticky.css('position','absolute');
        sticky.css('top',stopHeight);
      }
    }
        
  }
  
  $(window).scroll(function() {
     /* checkOffset();     */
  });
  
  
  $('.header nav li.has-dropdown a').click(function(e) {
    e.preventDefault();
       
  });
  
  // nav dropdown 
  $('.header .nav li a').mouseenter(function() {
     var target = $(this).attr('href');
        
        if(this.getAttribute("href").charAt(0) == "#") {          
          $('.nav-dropdown-panel.isVisible').hide();
           $(target).show();
           $(this).parent().addClass('active');
           
        }
        else {
          $('.nav-dropdown-panel.isVisible').hide();
        }
    });
    $('.header .nav>li, .nav-dropdown-panel').mouseleave(function() {
      
        $('.nav-dropdown-panel').hide();
      $(this).removeClass('active'); 
             
        if (!$('.header .nav li a.tc1').hasClass('current')) {        
            $('.header .nav li a.tc1').removeClass('active-parent');            
            
        }
      
        if (!$('.header .nav li a.tc2').hasClass('current')) {        
            $('.header .nav li a.tc2').removeClass('active-parent');
        }
            
        $('.nav-dropdown-panel.isVisible').show();
        
       $('.nav li.dropdown .obj').removeClass('active');
      
     });   
   
   $('.nav-dropdown-panel').mouseenter(function () {          
    $(this).stop(true, true).show(); 
      $(this).addClass('active');

        if ($(this).hasClass('isVisible')) {        
          $('.nav-dropdown-panel.isVisible').show();          
        }
        else {
          $('.nav-dropdown-panel.isVisible').hide();
        }
     
      if ($(this).hasClass('tc1')) {        
          $('.header .nav li a.tc1').addClass('active-parent');
          $('.nav li.dropdown .obj.tc1').addClass('active');
        }
        else if ($(this).hasClass('tc2')) { 
           $('.header .nav li a.tc2').addClass('active-parent');
          $('.nav li.dropdown .obj.tc2').addClass('active');
       }  
  }); 
  
  
  
  
  $(".accordion-title-bar").click(function(){
    $(this).next(".accordion-content").slideToggle(500).siblings('.accordion-content:visible').slideUp(500);
    $(this).toggleClass("active");    
    $(this).siblings().removeClass("active");
  });
  
  if ( $('.slides li').size() >= 0 ) {
    
    var $window = $(window);    
      
 
    // tiny helper function to add breakpoints
    function getGridSize() {
      return (window.innerWidth < 480) ? 3 : (window.innerWidth < 568) ? 5 : (window.innerWidth < 1024) ? 6 : (window.innerWidth < 1280) ? 5 : 6;
    }
  

    $(function() {
      SyntaxHighlighter.all();
    });
    
    if ( $('#product-thumb-slider').length ) {  

      $('#product-thumb-slider').flexslider({
          animation: "slide",
          controlNav: false,
          directionNav: true,
          animationLoop: false,
          slideshow: false, 
          minItems: getGridSize(), // use function to pull in initial value
          maxItems: getGridSize(), // use function to pull in initial value
          itemWidth: 152,
          itemMargin: 10    
        });  

        var slider = $('#product-thumb-slider').data('flexslider');

        $window.resize(function() {
          var gridSize = getGridSize();

          slider.vars.minItems = gridSize;
          slider.vars.maxItems = gridSize;
        });
    }
    
        
    $('.Color-thumb-slider').flexslider({
      animation: "slide",
      controlNav: false,
      directionNav: true,
      animationLoop: true,
      slideshow: false, 
      minItems: 3,
      maxItems: 3,
      itemWidth: 152,
      itemMargin: 10     
    }); 
    
    $('#product .thumbs').css('opacity', 0);
    
    //variant image slider
    $('#product .thumbs .slides .image a').on('click', function(){
      $('#product .thumbs .slides li').each(function(index){
        $(this).find('a').removeClass('active');
      });
      $(this).addClass('active');
    });
    $('#product .product-image-slider a img').one('load', function(){
      $('.swatch .slides li:first-child label')[0].click();
      $('#product .thumbs .slides .image a:first-child')[0].click();
    });
    
    $('.swatch .slides li label').on('click', function(){
      if ($('#product .thumbs .slides li:first-child').hasClass('featured_thumb')) {
        $('#product .thumbs .slides li:first-child').remove();
      }
      var img_link = $(this).find('.full_link').attr('src');
      var html = '<li class="featured_thumb" style="float:left;display:block;">'
                +'      <div class="image span2">'
      			+'        <a href="javascript:void(0);" class="cloud-zoom-gallery">'
                +'          <img src="'+img_link+'" class="product-photo-thumbs" data-image-id="" alt="" />'
                +'        </a>'
                +'      </div>'
                +'    </li>';
      $('#product .thumbs .slides li:first-child').before(html);
      $('#product .thumbs .slides li').each(function(index) {
        $(this).find('a').removeClass('active');
      });
      $('#product .thumbs .slides li:first-child a').addClass('active');
    });
    
    $('body').on('click', '#product .thumbs .slides .featured_thumb .image a', function(){
      $('.product-image-slider a').attr('href', $(this).find('img').attr('src'));
      $('.product-image-slider a img').attr('src', $(this).find('img').attr('src'));
      $('#product .thumbs .slides li').each(function(index) {
        $(this).find('a').removeClass('active');
      });
      $(this).addClass('active');

    });
    
    $(window).on('load', function(){
      setTimeout(function(){$('#product .thumbs').css('opacity', 1);}, 2000);
    });
    
    $('.variant_img_navs .next').on('click', function(){
      var current = $('#product .thumbs .slides .image a.active').parent().parent();
      var start_elm = $(current).next();
      var i = 0;
      while (i < 30 ) {
        if ($(start_elm).css('display') == 'block' || $(start_elm).hasClass('featured_thumb')) {
          $(start_elm).find('.image a')[0].click();
          break;
        }
        else {
          if ($(start_elm).prop('tagName') == 'LI') {
            start_elm = $(start_elm).next();
          } else {
            //$('#product .thumbs .slides li:first-child a')[0].click();
            start_elm = $('#product .thumbs .slides li');
            //break;
          }
        }
        i ++;
      }
    });
    $('.variant_img_navs .prev').on('click', function(){
      var current = $('#product .thumbs .slides .image a.active').parent().parent();
      var start_elm = $(current).prev();
      var i = 0;
      while (i < 30 ) {
        if ($(start_elm).css('display') == 'block' || $(start_elm).hasClass('featured_thumb')) {
          $(start_elm).find('.image a')[0].click();
          break;
        }
        else {
          if ($(start_elm).prop('tagName') == 'LI') {
            start_elm = $(start_elm).prev();
          } else {
            //$('#product .thumbs .slides li:last-child a')[0].click();
            var last_elm = $('#product .thumbs .slides li:last');
            console.log(last_elm);
            var j = 0;
            while (j < 30) {
              if ($(last_elm).css('display') == 'block' || $(last_elm).hasClass('featured_thumb')) {
                $(last_elm).find('a')[0].click();
                break;
              } else {
                last_elm = $(last_elm).prev();
                //console.log($(last_elm));
              }
              j ++;
            }
            break;
          }
        }
        i ++;
      }
    });
    $('#product .thumbs .slides span i').on('click', function(){
      $('#product .featured .product-image-slider a')[0].click();
    });
    
    

 /*   $('#product-image-slider').flexslider({
      animation: "slide",
      controlNav: false,
      animationLoop: true,
      slideshow: false,
      sync: "#product-thumb-slider",      
      useCSS: false
    });
   */ 
   
  }

  var status, width = $(window).width();
  
  if (width<480) status = true;
  else status = false;
  
  
    var slider = $('.bxslider').bxSlider({
      mode	: 'fade',
      adaptiveHeight: false,
      controls: true,
      pager: false,
      speed :600,
      pause: 5000,
      auto: true
    });
  
  
  $(window).resize(function() {
    
    width = $(window).width();
    
    if (width<480) status = false;
  	else status = false;
    
   slider.reloadSlider({
      mode: 'fade',
      adaptiveHeight: false,
      controls: true,
      pager: false,
      speed :600,
      pause: 5000,
      auto: true
    });
    
  });
});